// @flow

export default function adminUrl() {
  return '/admin'
}
